import React, { useEffect, useState, useRef, useMemo } from "react";
import AdminHeading from "../Heading/AdminHeading";
import {
  Slider,
  TextField,
  Box,
  Grid,
  Tab,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import {
  a125,
  a128,
  a131,
  a134,
  a149,
  a163,
  a181,
  a216,
  a218,
  a219,
  a220,
  a221,
  a222,
  a241,
  a242,
} from "../../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { InfinitySpin } from "react-loader-spinner";
import jsPDF from "jspdf";
import { ClipLoader } from "react-spinners";
import ErrorModal from "../../../Other Functions/popup";
import ReportList from "Components/support/customervendor/ReportList";
import style from "../../PagesStyles/AllReports.module.css";
import { Icon } from "@iconify/react";
import Skeleton from "UIComp/Skeleton";
import "./Reports.css";
import Category from "Components/Reports/Category";
import {
  fetchAllCategories,
  fetchAllDesigns,
  fetchAllProducts,
  fetchAllPurities,
  fetchAllSKU,
  fetchAllVendors,
} from "services/generalService";
import { useQuery } from "@tanstack/react-query";
import Product from "Components/Reports/Product";
import Design from "Components/Reports/Design";
import SKU from "Components/Reports/SKU";
import SKUKarigar from "Components/Reports/SKUKarigar";
import LabelledStock from "Components/Reports/LabelledStock";
import Packets from "Components/Reports/Packets";
import { useSearchParams } from "react-router-dom";
import Boxes from "Components/Reports/Boxes";

function AllReportNew() {
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams(0);
  const component = searchParams.get("component");

    const pdfRef = useRef(null);


  const generatePdf = async () => {
        if (!pdfRef.current) return;
        setLoader(true);
    
        try {
          // **STEP 1: Scroll entire div into view to ensure images load**
          pdfRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    
          // **STEP 2: Wait for 1 second to let off-screen images load**
          await new Promise((resolve) => setTimeout(resolve, 1000));
    
          // **STEP 3: Capture the full div including off-screen images**
          const canvas = await html2canvas(pdfRef.current, {
            scale: 2, // High quality
            useCORS: true, // Allow external images
            allowTaint: true, // Allow cross-origin images
            logging: true, // Enable logging for debugging
            windowWidth: document.documentElement.scrollWidth, // Capture full width
            windowHeight: document.documentElement.scrollHeight, // Capture full height
          });
    
          // Convert to image
          const imgData = canvas.toDataURL("image/png");
    
          console.log(imgData);
          
    
          // Get dynamic component size
          const imgWidth = 210; // A4 width in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
          // Create PDF dynamically sized to the content
          const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
          pdf.save("Catalouge.pdf");
          setLoader(false);
        } catch (error) {
          setLoader(false);
          console.error("Error generating PDF:", error);
        }
      };

  // -------------------- new developmenmt -------------------

  const {
    data: allCategories,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["report/category", clientCode],
    queryFn: fetchAllCategories,
    refetchOnWindowFocus: false,
  });
  const { data: allPurities } = useQuery({
    queryKey: ["report/purity", clientCode],
    queryFn: fetchAllPurities,
    refetchOnWindowFocus: false,
  });
  const { data: allProducts } = useQuery({
    queryKey: ["report/product", clientCode],
    queryFn: fetchAllProducts,
    refetchOnWindowFocus: false,
  });
  const { data: allDesigns } = useQuery({
    queryKey: ["report/design", clientCode],
    queryFn: fetchAllDesigns,
    refetchOnWindowFocus: false,
  });
  const { data: allVendors } = useQuery({
    queryKey: ["report/vendors", clientCode],
    queryFn: fetchAllVendors,
    refetchOnWindowFocus: false,
  });
  const { data: allSku } = useQuery({
    queryKey: ["report/sku", clientCode],
    queryFn: fetchAllSKU,
    refetchOnWindowFocus: false,
  });

  return (
    <>
      <AdminHeading />

      {/* {loading ? (
        // Show spinner while loading
        <div className="spinner-container">
          <ClipLoader size={50} color={"#123abc"} loading={loading} />
          <p>Loading data...</p>
        </div>
      ) : ( */}
      <div>
        <Box className="adminMainBodyBox">
          <AdminBreadCrump
            title={"Stock Transfer History"}
            companyName={"Loyalstring"}
            module={"Trading"}
            page={"Stock Transfer History"}
          />
        </Box>
        <Box className={style.adminAddCategoryMainBox}>
          <Box className="adminAddCategoryInnerBox">
            <Grid
              container
              justifyContent={{ xs: "center", sm: "space-between" }}
              alignItems={"start"}
              sx={{ flexDirection: { xs: "column", sm: "row" } }}
            >
              <Grid item xs={12} sm={12}>
                <Box mb={1} sx={{ textAlign: { xs: "center", sm: "left" } }}>
                  <Tabs
                    value={+(component || 0)}
                    onChange={(e, newValue) => {
                      console.log(newValue);
                      setSearchParams({ component: newValue });
                    }}
                    aria-label="stock transfer tabs"
                    TabIndicatorProps={{
                      style: { backgroundColor: "#0077d4" },
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                      "& .MuiTab-root": {
                        textTransform: "none",
                        color: "#000",
                        "&:hover": {
                          color: "#0077d4",
                        },
                      },
                      "& .Mui-selected": {
                        color: "#0077d4",
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#0077d4",
                        color: "#0077d4",
                      },
                    }}
                  >
                    <Tab label="Category" />
                    <Tab label="Product" />
                    <Tab label="Design" />
                    <Tab label="SKU Report" />
                    <Tab label="SKU / Karigar Report" />
                    <Tab label="Labelled Stock" />
                    <Tab label="Packets" />
                    <Tab label="Boxes" />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>

            {/* ----------------------components goes here------------------- */}

            {component == 0 && (
              <Category
                allCategories={allCategories}
                allPurities={allPurities}
                clientCode={clientCode}
                style={style}
              />
            )}
            {component == 1 && (
              <Product
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                clientCode={clientCode}
                style={style}
              />
            )}
            {component == 2 && (
              <Design
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
              />
            )}
            {component == 3 && (
              <SKU
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
                allVendors={allVendors}
                allSku={allSku}
              />
            )}
            {component == 4 && (
              <SKUKarigar
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
                allVendors={allVendors}
                allSku={allSku}
              />
            )}
            {component == 5 && (
              <LabelledStock
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
                allVendors={allVendors}
                allSku={allSku}
              />
            )}

            {component == 6 && (
              <Packets
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
                allVendors={allVendors}
                allSku={allSku}
              />
            )}

            {component == 7 && (
              <Boxes
                allCategories={allCategories}
                allPurities={allPurities}
                allProducts={allProducts}
                allDesigns={allDesigns}
                clientCode={clientCode}
                style={style}
                allVendors={allVendors}
                allSku={allSku}
              />
            )}
          </Box>
        </Box>
      </div>
      {/* )} */}
    </>
  );
}

export default AllReportNew;
